import React from 'react';
import { APP_STORE_URL, CONTACT_URL, SUPPORT_EMAIL } from '../constants';

const COLUMNS = [
  {
    heading: 'Explore',
    links: [
      { label: 'Features', href: '/#features' },
      { label: 'Situations', href: '/#situations' },
      { label: 'Screenshots', href: '/#screenshots' },
      { label: 'FAQ', href: '/#faq' },
    ],
  },
  {
    heading: 'Support',
    links: [
      { label: 'Contact us', href: CONTACT_URL, external: true },
      { label: SUPPORT_EMAIL, href: `mailto:${SUPPORT_EMAIL}` },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <a href="/" className="brand">
            <img src="/logo.png" alt="" className="brand__logo" />
            ConvoLines
          </a>
          <p>Practice the English you actually need — real conversations for the everyday moments that make you freeze.</p>
          <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="site-footer__badge">
            <img src="/images/app_store_badge_564x168.png" alt="Download ConvoLines on the App Store" width={141} height={42} />
          </a>
        </div>

        <nav className="site-footer__cols">
          {COLUMNS.map((col) => (
            <div className="site-footer__col" key={col.heading}>
              <h3>{col.heading}</h3>
              <ul>
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      {...(link.external ? { target: '_blank', rel: 'noreferrer' } : {})}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>

      <div className="site-footer__bar">
        <span>© {new Date().getFullYear()} ConvoLines. All rights reserved.</span>
        <span>Made for people who understand English but freeze when they speak.</span>
      </div>
    </footer>
  );
}
